import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'
import { toast } from 'sonner'
import type { TinyConfigInput, TinyProduto } from '@/lib/types'

export function useTinyStatus() {
  return useQuery({
    queryKey: ['tiny-status'],
    queryFn: async () => {
      return api.settings.getTinyStatus()
    },
  })
}

export function useSaveTinyConfig() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: TinyConfigInput) => {
      return api.settings.saveTinyConfig(data)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tiny-status'] })
      toast.success('Tiny ERP configurado com sucesso!')
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Erro ao configurar Tiny ERP')
    },
  })
}

export function useTestTinyConnection() {
  return useMutation({
    mutationFn: async () => {
      return api.settings.testTinyConnection()
    },
    onSuccess: (data) => {
      if (data.success) {
        toast.success('Conexão com Tiny ERP OK!')
      } else {
        toast.error(data.error || 'Falha na conexão')
      }
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Erro ao testar conexão')
    },
  })
}

export function useRemoveTiny() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      return api.settings.removeTiny()
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tiny-status'] })
      toast.success('Integração Tiny removida')
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Erro ao remover integração')
    },
  })
}

export function useTinyShippingMethods(enabled = true) {
  return useQuery({
    queryKey: ['tiny-shipping-methods'],
    queryFn: async () => {
      return api.settings.getTinyShippingMethods()
    },
    enabled,
  })
}

export function useTinyProductSearch(query: string) {
  return useQuery<TinyProduto[]>({
    queryKey: ['tiny-products', query],
    queryFn: async () => {
      const res = await api.creators.searchTinyProducts(query)
      return res
    },
    enabled: query.length >= 2,
    staleTime: 30_000,
  })
}
